// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__3RTa8"};